import Menu from "../../components/Menu";
import Report from "../../assets/img/report-black.svg";
import { Link } from "react-router-dom";
import { Stethoscope, Building, CalendarCheck, Headphones } from 'lucide-react';

function FinancialPage() {
 const reports = [
    {
      name: "Repasse - Médico Solicitante",
      path: "/financial/repasse-medico",
      icon: <Stethoscope />
    },
    {
      name: "Repasse - Empresa Realizante",
      path: "/financial/repasse-empresa",
      icon: <Building />
    },
    {
      name: "Repasse - Consultas",
      path: "/financial/repasse-consulta",
      icon: <CalendarCheck />
    },
    {
      name: "Repasse - Atendentes",
      path: "/financial/repasse-atendentes",
      icon: <Headphones />
    }
  ];

  const screenTela = (
    <div className="screenContainer" style={{ paddingRight: "0px" }}>
      <div className="row row-container">
        <h1 className="col-12">
          {" "}
          <img style={{ width: "40px" }} alt="svg" src={Report} />{" "}
          <span className="name-screen-title name-screen-professionals">
            Financeiro
          </span>{" "}
        </h1>
        <div className="row row-subcontainer">
          {reports.map((data, index) => {
            return (
              <Link
                key={index}
                to={data.path}
                className="col-12 col-sm-6 col-md-6 col-lg-4 cursor-pointer">
                {/* style={{ padding: "0px 10px", cursor: "pointer" }}> */}
                  <div
                    className="p-4 card-list d-flex align-items-center">
                    <div className="me-3">{data.icon}</div>
                    <span
                      style={{ textAlign: "start" }}
                      className="card-list-name truncated-text">
                      {data.name}
                    </span>
                  </div>
               
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
  return <Menu screen={screenTela} />;
}

export default FinancialPage;
